import React from 'react';
import { motion } from 'framer-motion';
export function SuspensionNotice() {
  return <motion.section initial={{
    opacity: 0,
    y: 16
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    delay: 0.15,
    ease: 'easeOut'
  }} className="w-full" aria-labelledby="suspension-heading" data-id="element-89">
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-90">
        {/* Brand Orange left accent bar */}
        <div className="flex flex-col sm:flex-row" data-id="element-91">
          <div className="h-2 sm:h-auto sm:w-2 bg-g7-orange flex-shrink-0" aria-hidden="true" data-id="element-92" />
          <div className="flex-1 px-6 sm:px-10 py-10 sm:py-14" data-id="element-93">
            {/* Status badge */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.4,
            delay: 0.4
          }} className="mb-6" data-id="element-94">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-orange-50 border border-orange-100" data-id="element-95">
                <motion.span animate={{
                opacity: [1, 0.5, 1]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="block h-2 w-2 rounded-full bg-g7-orange" aria-hidden="true" data-id="element-96" />
                <span className="text-xs font-bold uppercase tracking-wider text-g7-orange" data-id="element-97">
                  Service Suspended
                </span>
              </span>
            </motion.div>

            {/* Main heading */}
            <h1 id="suspension-heading" className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-98">
              This website is currently unavailable
            </h1>

            {/* Explanation */}
            <p className="text-base sm:text-lg text-slate-600 max-w-2xl leading-relaxed" data-id="element-99">
              The hosting provider for this website,{' '}
              <span className="font-semibold text-slate-800" data-id="element-100">CloudZyro</span>,
              has had their account suspended due to a billing issue.
            </p>
          </div>
        </div>
      </div>
    </motion.section>;
}